import { type ReactNode, useRef } from "react"

/**
 * Un enlace-botón que abre el selector de archivos (23/10).
 *
 * ⚠ **No es un `<label>` con el `<input type="file" class="sr-only">` dentro.** Pulsar la
 * etiqueta ENFOCA el campo oculto, y el navegador desplaza los ancestros con `overflow`
 * —también los `hidden` del armazón— para traerlo a la vista: el área de trabajo subía y
 * se quedaba cortada a la mitad (Mi ficha, «Cargar»). Con `click()` desde un botón el
 * campo no recibe el foco, que es lo que ya hace `AdjuntosNuevos`.
 */
export function BotonArchivo({
  children,
  accept,
  etiqueta,
  disabled,
  onArchivo,
}: {
  children: ReactNode
  accept: string
  /** Nombre accesible del campo: lo usan también las pruebas. */
  etiqueta: string
  disabled?: boolean
  onArchivo: (archivo: File) => void
}) {
  const entrada = useRef<HTMLInputElement>(null)
  return (
    <>
      <button
        type="button"
        disabled={disabled}
        onClick={() => entrada.current?.click()}
        className="inline-flex cursor-pointer items-center gap-1 text-xs underline-offset-2 hover:underline disabled:opacity-50"
      >
        {children}
      </button>
      <input
        ref={entrada}
        type="file"
        accept={accept}
        tabIndex={-1}
        className="sr-only"
        aria-label={etiqueta}
        disabled={disabled}
        onChange={(e) => {
          const archivo = e.target.files?.[0]
          if (archivo) onArchivo(archivo)
          // Sin esto, elegir el mismo archivo dos veces seguidas no dispara `change`.
          e.target.value = ""
        }}
      />
    </>
  )
}
